import React from 'react';
import PropTypes from 'prop-types';

/**
 * @function CardCta
 * @description create a CardCta component which displays an icon, label, description
 * and takes a link to redirect the user to
 */
const CardCta = ({description, imageModifier, label, path}) => {
    return (
        <a className="card-cta"
           href={path}>
            <div className="card-cta__icon-container">
                <div className={`card-cta__icon card-cta--${imageModifier}`} />
            </div>
            <p className="card-cta__label">{label}</p>
            <p className="card-cta__description">{description}</p>
        </a>
    );
};

/**
 * @property CardCta.propTypes
 * @description property types for components
 * @type {string} description: text that shows under the label
 * @type {string} imageModifier: class modifier that assigns the background image in the scss file
 * @type {string} label: text that describes where the user will be linked to
 * @type {string} path: absolute or relative url
 */
CardCta.propTypes = {
    description: PropTypes.string.isRequired,
    imageModifier: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
};

export default CardCta;



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.CardCta.js